import React, { useState } from 'react';

const NicknameInput = ({ onNicknameSet }) => {
  const [nickname, setNickname] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const trimmedNickname = nickname.trim();
    
    if (!trimmedNickname) {
      setError('Please enter a nickname');
      return;
    }
    
    if (trimmedNickname.length > 12) {
      setError('Nickname must be 12 characters or less');
      return;
    }
    
    if (trimmedNickname.length < 1) {
      setError('Nickname must be at least 1 character');
      return;
    }
    
    // Store nickname in localStorage
    localStorage.setItem('bomberman-nickname', trimmedNickname);
    onNicknameSet(trimmedNickname);
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#1a1a1a',
      color: '#ffffff',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#2a2a2a',
        border: '2px solid #444',
        borderRadius: '12px',
        padding: '40px',
        maxWidth: '400px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
      }}>
        <h1 style={{
          fontSize: '32px',
          marginBottom: '8px',
          background: 'linear-gradient(45deg, #ff6b6b, #4ecdc4)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontWeight: 'bold'
        }}>
          💣 Bomberman
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#aaa',
          marginBottom: '30px'
        }}>
          Choose your nickname to get started!
        </p>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="text"
              value={nickname}
              onChange={(e) => {
                setNickname(e.target.value);
                setError('');
              }}
              placeholder="Enter your nickname"
              maxLength="12"
              style={{
                width: '100%',
                padding: '15px',
                fontSize: '16px',
                backgroundColor: '#333',
                border: error ? '2px solid #ff4444' : '2px solid #555',
                borderRadius: '8px',
                color: '#fff',
                outline: 'none',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#4ecdc4';
              }}
              onBlur={(e) => {
                if (!error) {
                  e.target.style.borderColor = '#555';
                }
              }}
              autoFocus
            />
            
            <div style={{
              textAlign: 'right',
              marginTop: '5px',
              fontSize: '12px',
              color: '#888'
            }}>
              {nickname.length}/12
            </div>
          </div>
          
          {error && (
            <div style={{
              color: '#ff4444',
              fontSize: '14px',
              marginBottom: '20px',
              padding: '8px',
              backgroundColor: 'rgba(255, 68, 68, 0.1)',
              borderRadius: '4px',
              border: '1px solid rgba(255, 68, 68, 0.3)'
            }}>
              {error}
            </div>
          )}
          
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '15px',
              fontSize: '18px',
              fontWeight: 'bold',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease',
              boxShadow: '0 4px 12px rgba(40, 167, 69, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#218838';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#28a745';
            }}
          >
            Start Playing!
          </button>
        </form>
        
        <div style={{
          marginTop: '20px',
          fontSize: '12px',
          color: '#666'
        }}>
          Your nickname will be saved in your browser
        </div>
      </div>
    </div>
  );
};

export default NicknameInput;